export function resolveAccrualMatchListIncludes(
    includeAccrualMatchDetails?: boolean,
): {
    includeAccrualMatchDetails: boolean;
    includeAccrualMatchSuggestions: boolean;
} {
    const details = includeAccrualMatchDetails ?? true;
    return {
        includeAccrualMatchDetails: details,
        includeAccrualMatchSuggestions: details,
    };
}
